import { AxiosResponse } from 'axios'
import ApiService from '@/plugins/api-plugin/services/api.service'
import {
    FinanceReportJobCreatedDao,
    FinanceReportJobDao,
    FinanceReportLookupsDao,
} from '@/interfaces/finance-report/FinanceReport.dao'
import { CreateFinanceReportJobDto } from '@/interfaces/finance-report/FinanceReportJob.dto'

export default class FinanceReportService extends ApiService {
    async getLookups(): Promise<FinanceReportLookupsDao | null> {
        return this.request<undefined, FinanceReportLookupsDao>(
            'GET',
            '/finance-reports/lookups',
            undefined,
            undefined,
            undefined,
            'getFinanceReportLookups',
        ).catch(() => null)
    }

    async createJob(dto: CreateFinanceReportJobDto): Promise<FinanceReportJobCreatedDao | null> {
        return this.request<CreateFinanceReportJobDto, FinanceReportJobCreatedDao>(
            'POST',
            '/finance-reports/jobs',
            undefined,
            dto,
            undefined,
            'createFinanceReportJob',
        ).catch(() => null)
    }

    async getJob(jobId: string): Promise<FinanceReportJobDao | null> {
        return this.request<undefined, FinanceReportJobDao>(
            'GET',
            `/finance-reports/jobs/${encodeURIComponent(jobId)}`,
            undefined,
            undefined,
            undefined,
            'getFinanceReportJob',
        ).catch(() => null)
    }

    async downloadJob(jobId: string): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            `/finance-reports/jobs/${encodeURIComponent(jobId)}/download`,
            undefined,
            undefined,
            'blob',
            'downloadFinanceReportJob',
        ).catch(() => null)
    }
}
